import APP_ROUTES from 'app/constants/routes/app';
import { getItem } from 'app/utils/session';
import { Redirect, Route } from 'react-router';

const RoleRoute = ({ component: Component, allowedRoles = [], ...rest }) => {
    const token = getItem('token');
    const storedUser = getItem('user_data');
    let roleId;
    try { roleId = storedUser ? JSON.parse(storedUser).roleId : undefined; } catch (error) { roleId = undefined; }
    return <Route {...rest} render={(props) => {
        if (!token) return <Redirect to={APP_ROUTES.LOGIN} />;
        if (!allowedRoles.includes(roleId)) return <Redirect to={APP_ROUTES.HOME} />;
        return <Component {...props} />;
    }} />;
};
export default RoleRoute;
